import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { environment } from 'src/environments/environment';
import { Paginated } from 'src/app/shared/paginated.model';
import {
  AddConnectionRequest,
  ConnectionDetails,
  ConnectionEquipment,
  ConnectionEquipmentDetails,
  ConnectionEquipmentInfo,
  ConnectionPing,
  ConnectionStatus,
  ConnectivityCatalogEntry,
  ConnectivityItem
} from '../models/connectivity.model';
import {
  CatalogItem,
  ConnectivityCatalogEntryGetRequest,
  ConnectivityCatalogType,
  ContentType
} from '../models/connectivity.model';

@Injectable()
export class ConnectivityService {

  constructor(private http: HttpClient) { }

  getConnectionsByCompanyId(companyId: number): Observable<ConnectivityItem[]> {
    return this.http.get<ConnectivityItem[]>(`${environment.apiEndpoint}/api/v1/connectivity/connections/by-company-id/${companyId}`);
  }

  getConnection(id: number): Observable<ConnectionDetails> {
    return this.http.get<ConnectionDetails>(`${environment.apiEndpoint}/api/v1/connectivity/connections/${id}`);
  }

  getConnectionStatus(id: number): Observable<ConnectionStatus> {
    return this.http.get<ConnectionStatus>(`${environment.apiEndpoint}/api/v1/connectivity/connections/${id}/status`);
  }

  getConnectionPing(id: number): Observable<ConnectionPing> {
    return this.http.get<ConnectionPing>(`${environment.apiEndpoint}/api/v1/connectivity/connections/${id}/ping`);
  }

  getEquipmentByConnectionId(id: number): Observable<ConnectionEquipment[]> {
    return this.http.get<ConnectionEquipment[]>(`${environment.apiEndpoint}/api/v1/connectivity/equipments/by-connection-id/${id}`);
  }

  getEquipmentDetails(id: number): Observable<ConnectionEquipmentDetails> {
    return this.http.get<ConnectionEquipmentDetails>(`${environment.apiEndpoint}/api/v1/connectivity/equipments/${id}`)
  }

  addConnection(payload: AddConnectionRequest): Observable<ConnectivityItem[]> {
    return this.http.post<ConnectivityItem[]>(`${environment.apiEndpoint}/api/v1/connectivity/connections`,
      payload);
  }

  createEquipment(payload: ConnectionEquipmentInfo) {
    return this.http.post(`${environment.apiEndpoint}/api/v1/connectivity/equipments`,
      payload);
  }

  updateEquipment(id: number, payload: ConnectionEquipmentInfo): Observable<ConnectionEquipmentInfo> {
    return this.http.put<ConnectionEquipmentInfo>(`${environment.apiEndpoint}/api/v1/connectivity/equipments/${id}`, payload);
  }

  public getDevices(queryParams: ConnectivityCatalogEntryGetRequest): Observable<Paginated<ConnectivityCatalogEntry>> {
    let params = new HttpParams();
    Object.keys(queryParams).forEach((k: string) => {
      params = params.append(k, queryParams[k])
    });
    return this.http.get<Paginated<ConnectivityCatalogEntry>>(`${environment.apiEndpoint}/api/v1/connectivity/equipment-catalog-entry`, {
      params: params
    });
  }

  public addEntry(item: CatalogItem) {
    return this.http.post(`${environment.apiEndpoint}/api/v1/connectivity/equipment-catalog-entry`, item);
  }

  public editEntry(id: number, item: CatalogItem) {
    return this.http.put(`${environment.apiEndpoint}/api/v1/connectivity/equipment-catalog-entry/${id}`, item);
  }

  public deleteEntry(id: number) {
    return this.http.delete(`${environment.apiEndpoint}/api/v1/connectivity/equipment-catalog-entry/${id}`);
  }

  public addDocumentToEntry(request: FormData) {
    return this.http.post(`${environment.apiEndpoint}/api/v1/connectivity/equipment-catalog-entry/links`, request);
  }

  public deleteEntryDocument(id: number) {
    return this.http.delete(`${environment.apiEndpoint}/api/v1/connectivity/equipment-catalog-entry/links/${id}`);
  }

  lockConnectivity(id: number): Observable<ConnectionDetails> {
    return this.http.put<ConnectionDetails>(`${environment.apiEndpoint}/api/v1/connectivity/connections/by-company-id/${id}/lock`,
      null);
  }

  unlockConnectivity(id: number): Observable<ConnectionDetails> {
    return this.http.put<ConnectionDetails>(`${environment.apiEndpoint}/api/v1/connectivity/connections/by-company-id/${id}/unlock`,
      null);
  }
}
